import { Iodine } from "@kingshott/iodine";

const DEFAULT_QUESTION_FORM_DATA = {
    name: {
        value: "",
        errorMessage: false,
        blurred: false,
        rules: ["required"],
    },
    email: {
        value: "",
        errorMessage: false,
        blurred: false,
        rules: ["required", "email"],
    },
    question: {
        value: "",
        errorMessage: false,
        blurred: false,
        rules: ["required", "maximum:200"],
    },
    dsgvo: {
        value: false,
        errorMessage: false,
        blurred: false,
        rules: ["truthy"],
    },
};

window.questionForm = (messages) => ({
    iodineInstance: null,
    isVisibleForm: false,
    isFormSend: false,
    formSendError: false,
    isButtonLoading: false,
    formData: JSON.parse(JSON.stringify(DEFAULT_QUESTION_FORM_DATA)),
    messages,

    initialize() {
        this.iodineInstance = new Iodine();
        this.iodineInstance.messages.required = this.messages.required;
        this.iodineInstance.messages.truthy = this.messages.required;
        this.iodineInstance.messages.email = this.messages.email;
        this.iodineInstance.messages.maximum = this.messages.maximum;

        Object.keys(this.formData).map((key) => this.$watch(`formData.${key}.value`, () => this.changeValue(key)));
    },

    showForm() {
        this.isVisibleForm = true;
        this.isFormSend = false;
        this.formSendError = false;
    },

    hideForm() {
        this.isVisibleForm = false;
        this.resetForm();
    },

    resetForm() {
        this.isFormSend = false;
        this.formSendError = false;
        this.isButtonLoading = false;
        this.formData = JSON.parse(JSON.stringify(DEFAULT_QUESTION_FORM_DATA));
    },

    changeValue(key) {
        this.formData[key].blurred = true;
        this.updateErrorMessages(key);
    },

    updateErrorMessages(key) {
        this.formData[key].errorMessage = this.getErrorMessage(key);
    },

    getErrorMessage(key) {
        const error = this.iodineInstance.is(this.formData[key].value, this.formData[key].rules);
        if (error !== true && this.formData[key].blurred) {
            return this.iodineInstance.getErrorMessage(error);
        }
        return false;
    },

    form: {
        ["@submit.prevent"](event) {
            const invalidElements = Object.keys(this.formData).filter((key) => {
                return this.iodineInstance.is(this.formData[key].value, this.formData[key].rules) !== true;
            });

            if (invalidElements.length > 0) {
                Object.keys(this.formData).map((key) => {
                    this.formData[key].blurred = true;
                    this.updateErrorMessages(key);
                });
            } else {
                this.isButtonLoading = true;
                const action = event.target.getAttribute("action");
                let data = {};
                Object.keys(this.formData).map((key) => {
                    data[key] = this.formData[key].value;
                });

                fetch(action, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ data }),
                })
                    .then((response) => response.json())
                    .then((json) => {
                        if (!json.success) {
                            throw new Error(json.message);
                        }
                        this.isFormSend = true;
                        this.isButtonLoading = false;
                    })
                    .catch((error) => {
                        this.isFormSend = true;
                        this.formSendError = error.message;
                        this.isButtonLoading = false;
                    });
            }
        },
    },
});
